export type { Props } from './banner-with-paper-layout-dumb';
export { default as BannerWithPaperLayoutDumb } from './banner-with-paper-layout-dumb';
